"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamp = Timestamp;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const date_fns_1 = require("date-fns");
const react_intl_1 = require("react-intl");
const Timestamp_style_1 = require("./Timestamp.style");
function Timestamp({ now = new Date(), date, className }) {
    if ((0, date_fns_1.isToday)(date)) {
        return ((0, jsx_runtime_1.jsxs)(Timestamp_style_1.Time, { className: className, children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.date.today" }), " ", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedTime, { value: date })] }));
    }
    if ((0, date_fns_1.isYesterday)(date)) {
        return ((0, jsx_runtime_1.jsxs)(Timestamp_style_1.Time, { className: className, children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.date.yesterday" }), " ", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedTime, { value: date })] }));
    }
    if ((0, date_fns_1.isSameWeek)(now, date, { weekStartsOn: 1 })) {
        return ((0, jsx_runtime_1.jsxs)(Timestamp_style_1.Time, { className: className, children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedDate, { value: date, weekday: "long" }), " ", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedTime, { value: date })] }));
    }
    return ((0, jsx_runtime_1.jsx)("time", { className: className, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedDate, { value: date, year: (0, date_fns_1.isSameYear)(now, date) ? undefined : 'numeric', month: "long", day: "numeric", weekday: undefined }) }));
}
